import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { Trans } from '@lingui/react/macro';

export interface DispensedColorProps {
  color: readonly [number, number, number] | null | undefined;
}

export const DispensedColor = ({ color }: DispensedColorProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography color="textDisabled" fontSize="120%">
        →
      </Typography>
      <Tooltip title={<Trans>Dispensed color</Trans>}>
        <Stack
          width={24}
          height={24}
          borderRadius="50%"
          border={2}
          borderColor={(theme) => theme.palette.grey[300]}
          sx={(theme) => ({
            backgroundColor: color ? `rgb(${color.join(',')})` : theme.palette.grey[100],
          })}
          alignItems="center"
          justifyContent="center"
        >
          {!color && (
            <Typography variant="caption" color="textDisabled" lineHeight={1} fontWeight={600}>
              ?
            </Typography>
          )}
        </Stack>
      </Tooltip>
    </Stack>
  );
};
